var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-by-side"},[_c('div',{staticClass:"badge",class:{
    small: _vm.size === 'small',
    medium: _vm.size === 'medium',
    large: _vm.size === 'large',
    'badge-status': _vm.type === 'payable' || _vm.type === 'receivable',
    blue: _vm.type === 'blue',
    primary: _vm.type === 'primary',
    secondary: _vm.type === 'secondary',
    payable: _vm.type === 'payable',
    receivable: _vm.type === 'receivable',
    success: _vm.type === 'success',
    warning: _vm.type === 'warning',
    info: _vm.type === 'info',
    edit: _vm.type === 'edit',
    danger: _vm.type === 'danger',
    default: _vm.type === 'default',
  }},[_c('i',{class:_vm.classIcon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }